import PropTypes from "prop-types"

export const FACTOR_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  getter: PropTypes.func.isRequired,
  favorite: PropTypes.bool,
  label: PropTypes.string.isRequired,
  priorityOrder: PropTypes.number,
  value: PropTypes.number,
})

export const FACTOR_CATEGORY_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  getter: PropTypes.func,
  background: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  factors: PropTypes.arrayOf(FACTOR_SHAPE),
})

export const FACTOR_CATEGORIES_SHAPE = PropTypes.arrayOf(FACTOR_CATEGORY_SHAPE)
